import {
  REGION_COUNTRY_CODE_MAPPING,
  languages,
  type Languages,
} from '../../../../i18n/i18n.language-config';

/**
 * The cleave.js options each country's phone number is typed with.
 *
 * <p>Copied from the three phone fields this page's Mantine field replaces
 * (`USPhoneField`, `UkPhoneField`, `AUPhoneField`) so a number keeps being
 * grouped the way policyholders on that platform already see it -- dropping
 * the formatting was the visible regression when the field moved to Mantine.
 */
export const phoneFormatFor = (countryCode: string) => {
  if (countryCode === REGION_COUNTRY_CODE_MAPPING[languages['en-GB']]) {
    return {
      delimiters: [' ', ' ext. '],
      blocks: [5, 6, 10],
      delimiterLazyShow: true,
    };
  }

  if (countryCode === REGION_COUNTRY_CODE_MAPPING[languages['en-AU']]) {
    return {
      delimiters: [' ', ' ', ' ext. '],
      blocks: [1, 4, 4, 6],
      delimiterLazyShow: true,
    };
  }

  return {
    delimiters: ['(', ') ', '-', ' ext. '],
    blocks: [0, 3, 3, 4, 10],
    delimiterLazyShow: true,
  };
};

/** The dialling code a platform's policyholders default to. */
export const defaultCountryCodeFor = (language: Languages): string =>
  REGION_COUNTRY_CODE_MAPPING[language] ??
  REGION_COUNTRY_CODE_MAPPING[languages['en-US']];
